module.exports = __webpack_public_path__ + "static/media/sale-2x.abceba2f.png";